module.exports = __webpack_public_path__ + "img/f21d0e7.jpg";